import axios from "axios";

import getErrorDetails from "./helpers/getErrorDetails";
import paramsSerializer from "./helpers/paramsSerializer";
import { addPaginationAndSort, ORDER_DESC } from "./helpers/pagination";
import { MISSING_CLIENT_CREDENTIALS } from "../constants/errors";

export async function getClients(params, options) {
  const paginationParams = addPaginationAndSort({
    orderBy: "createdAt",
    order: ORDER_DESC,
    // TODO
    // remove after implementing pagination
    limit: 999,
    ...params,
  });

  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/clients`,
      params: { ...params, ...paginationParams },
      paramsSerializer,
    });
    const { data = {} } = response;

    return {
      list: data,
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getClient(id, options) {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/clients/${id}`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function postClient(client, options) {
  try {
    const response = await axios({
      ...options,
      method: "POST",
      url: `/clients`,
      data: client,
    });
    const { data = {} } = response;
    return await getClient(data.id, options);
  } catch (error) {
    const MISSING_CREDENTIALS_ERROR_MESSAGE = "Customer Credentials not found";

    if (
      error?.response?.data?.exception?.message ===
      MISSING_CREDENTIALS_ERROR_MESSAGE
    ) {
      const error = {
        message: MISSING_CLIENT_CREDENTIALS,
        code: MISSING_CLIENT_CREDENTIALS,
      };

      throw error;
    }

    throw getErrorDetails(error);
  }
}

export async function patchClient(id, client, options) {
  try {
    const response = await axios({
      ...options,
      method: "PUT",
      url: `/clients/${id}`,
      data: client,
    });
    const { data = {} } = response;
    return await getClient(data.id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function deleteClient(id, options) {
  try {
    await axios({
      ...options,
      method: "DELETE",
      url: `/clients/${id}`,
    });
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function regenerateSecret(id, options) {
  try {
    await axios({
      ...options,
      method: "POST",
      url: `/clients/${id}/secret/regenerate`,
    });
    return await getClient(id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}
